import React, { useEffect, useRef } from "react";
import "./TravelThemes.css";

import WeekendIcon from "../../assets/images/travel-themes/weekend.png";
import YouthIcon from "../../assets/images/travel-themes/youth.png";
import AdventureIcon from "../../assets/images/travel-themes/adventure.png";
import BeachIcon from "../../assets/images/travel-themes/beach.png";
import FamilyIcon from "../../assets/images/travel-themes/family.png";
import HoneymoonIcon from "../../assets/images/travel-themes/honeymoon.png";
import PilgrimageIcon from "../../assets/images/travel-themes/pilgrimage.png";
import LuxuryIcon from "../../assets/images/travel-themes/luxury.png";

const TravelThemes = () => {
  const sliderRef = useRef(null); // Create a reference to the carousel

  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.append(sliderRef.current.querySelector(".themes-carousel>:first-child"));
    }
  };

  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.prepend(sliderRef.current.querySelector(".themes-carousel>:last-child"));
    }
  };

  // Autoplay functionality
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext(); // This will move the first child to the last, creating the carousel effect.
    }, 4000); // 4000 milliseconds (4 seconds) interval for autoplay

    // Cleanup interval when component unmounts
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="travelthemes">
      <h1>
        <span>Premium</span> Travel Experiences For
      </h1>
      <p>Find your perfect getaway, tailored to your interests</p>

      {/* Tour section */}
      <div className="themes-carousel" ref={sliderRef}>
        {/* Carousel items */}
        <div>
          <img src={WeekendIcon} alt="weekend.png" width="75" height="75" />
          <h5>Weekend</h5>
        </div>
        <div>
          <img src={HoneymoonIcon} alt="honeymoon.png" width="75" height="75" />
          <h5>Honeymoon</h5>
        </div>
        <div>
          <img src={AdventureIcon} alt="adventure.png" width="75" height="75" />
          <h5>Adventure</h5>
        </div>
        <div>
          <img src={BeachIcon} alt="beach.png" width="75" height="75" />
          <h5>Beach</h5>
        </div>
        <div>
          <img src={PilgrimageIcon} alt="pilgrimage.png" width="75" height="75" />
          <h5>Pilgrimage</h5>
        </div>
        <div>
          <img src={AdventureIcon} alt="adventure.png" width="75" height="75" />
          <h5>Safari Trails</h5>
        </div>
        <div>
          <img src={YouthIcon} alt="youth.png" width="75" height="75" />
          <h5>Youth Holidays</h5>
        </div>
        <div>
          <img src={FamilyIcon} alt="family.png" width="75" height="75" />
          <h5>Family Vacation</h5>
        </div>
        <div>
          <img src={LuxuryIcon} alt="luxury.png" width="75" height="75" />
          <h5>Luxury</h5>
        </div>
      </div>

      {/* Navigation Arrows */}
      <div className="arrows">
        <button id="prev" onClick={handlePrev}>
          <span className="arrow arrow-left"></span>
        </button>
        <button id="next" onClick={handleNext}>
          <span className="arrow arrow-right"></span>
        </button>
      </div>
    </div>
  );
};

export default TravelThemes;
